import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "@shared/auth/auth.service";
import { SharedService } from "@shared/services/shared.service";
import { IBusinessInitialSiteVisitViewModel } from "app/models/complaints/siteVisit";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { SiteVisitService } from "app/services/complaint/siteVisit.service";
import { InitialSiteVisitEditComponent } from "../initialSiteVisitEdit/initialSiteVisitEdit.component";
import { Subscription } from "rxjs";



@Component({
  selector: 'shared-initialSiteVisit',
  templateUrl: './initialSiteVisit.component.html',
  styleUrls: ['./initialSiteVisit.component.scss']
})

export class InitialSiteVisitComponent implements OnInit {

  @Input() parentPanel: number = 0;

  visitSubscription: Subscription;

  complaintId: number = 0;
  businessId: number = 0;
  isAdmin: boolean = false;
  siteVisit: number = 0;
  siteVisitList: IBusinessInitialSiteVisitViewModel[] = [];


  displayedColumns: string[] = ['action', 'complaintId', 'visitDate', 'visitConducted', 'violationFound',
    'siteVisitDetails', 'siteVisitNotes'];
  dataSource = new MatTableDataSource<IBusinessInitialSiteVisitViewModel>(this.siteVisitList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    private siteVisitService: SiteVisitService,
    private complaintService: ComplaintService,
    private sharedService: SharedService,
    private authService: AuthService,
    private modalService: MatDialog
  ) {

  }

  ngOnInit(): void {
    this.isAdmin = this.authService.isAdmin;

    this.visitSubscription = this.siteVisitService.updateSiteVistEvent.subscribe((data: number) => {
      this.siteVisitList = this.siteVisitService.siteVisit.initialSiteVisits;
      this.dataSource.data = this.siteVisitList;
      this.complaintId = this.siteVisitService.complaintId;
    });
  }

  ngOnDestroy() {
    this.visitSubscription.unsubscribe();
  }

  newVisit() {
    if (this.siteVisitList.length > 0) {
      this.sharedService.openConfirm("This business has already had an initial site visit. Are you sure you want to add an initial site visit?");
      this.sharedService.confirmed().subscribe(
        confirmed => {
          if (confirmed) {
            this.newInitialSiteVisit();
          }
        }
      );    }
    else{
      this.newInitialSiteVisit();
    }
  }

  newInitialSiteVisit() {
    let newSite = true
    let allowAdd = true;
    let newSiteVisit: IBusinessInitialSiteVisitViewModel = {
      id: 0,
      complaintId: this.complaintId,
      origComplaintDate: '',
      subsequentComplaintDate: '',
      visitDate: '',

      allowEditing: true,
      notes: '',
      visitConducted: 1,
      visitConductedReason: null,
      violationFound: 0
    }
    if (this.siteVisitList.length > 0) {
      this.sharedService.openConfirm('This business has already had an initial site visit.\n\nAre you sure you want to add an initial site visit?');

      this.sharedService.confirmed().subscribe(
        confirmed => {
          if (confirmed) {
            this.editInitialSiteVisit(newSiteVisit);
          }
        }
      );
    }
    else{
      this.editInitialSiteVisit(newSiteVisit);
    }

  }

  removeInitialSiteVisit(visit: IBusinessInitialSiteVisitViewModel) {
    this.sharedService.openConfirm("Are you sure you want to delete this visit?");

    this.sharedService.confirmed().subscribe(
      confirmed => {
        if (confirmed) {
          this.siteVisitService.deleteSiteVisits(visit.id, this.siteVisitService.statusInitial).subscribe({
            next: response => {
              this.siteVisitService.getSiteVisitData(this.siteVisitService.siteVisit.businessId);
              this.sharedService.toastr.success("Site Visit deleted.");
            },
            error: e => {
              this.sharedService.toastr.error("Could not delete site visit data.");
            },
          });
        }
      }
    );
  }

  editInitialSiteVisit(visit: IBusinessInitialSiteVisitViewModel) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = true;
    config.minWidth = 600;
    config.maxWidth = 600;
    config.maxHeight = 800;
    config.data = {
      siteVisit: visit,
      siteVisitItems: this.siteVisitList
    };
    const dialogRef = this.modalService.open(InitialSiteVisitEditComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.siteVisitService.getSiteVisitData(this.siteVisitService.siteVisit.businessId);
        }
      },
      error => this.sharedService.toastr.error("Error"),
      () => { }
    );
  }

  gotoComplaint(complaint: IBusinessInitialSiteVisitViewModel) {
    this.complaintService.complaintId = complaint.complaintId;
    this.complaintService.complaintTab = 4;
    this.complaintService.complaintVisitTab = 0;
    this.sharedService.doRedirect('complaint/complaint/' + complaint.complaintId);
  }

}